import { Button, Modal } from '../../../components'
import { DeletePersonalTimeoffI } from './type'
import { useAppDispatch } from '../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { deleteTimeOff } from '../api'
import { deleteTimeoffRequestsList } from '../slice'

const DeletePersonalTimeoff = ({
    show,
    onClose,
    id,
}: DeletePersonalTimeoffI) => {
    // const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleDeleteTimeoff = async () => {
        dispatch(SHOW_LOADER())
        try {
            const response = await deleteTimeOff(id as string)
            if (response.status === 200) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: 'Timeoff deleted successfully',
                        type: 'success',
                    })
                )
            }
            dispatch(deleteTimeoffRequestsList(id as string))
        } catch (error) {
            console.error(error)
        } finally {
            dispatch(HIDE_LOADER())
            onClose(false)
        }
    }

    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={'Delete Timeoff'}
            body={
                <>
                    <p className="del-desc">
                        {'Are you sure you want to delete this timeoff ?'}
                    </p>
                    <div className="footer-block">
                        <Button type="submit" onClick={handleDeleteTimeoff}>
                            YES
                        </Button>
                        <Button
                            type="button"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DeletePersonalTimeoff
